<template>
  <div class="exception-logs-box outer-page-primary">
    <div class="title-box header-box">
      <div class="symbol" />
      <div class="title">下载统计</div>
    </div>
    <div class="operation-box">
      <div class="top-box">
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box searchLabel">项目名称：</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="mini"
                filterable
                remote
                clearable
                :remote-method="filterProj"
                :loading="filterProjLoading"
                :popper-append-to-body="false"
                placeholder="请输入项目名称"
                v-model="projId"
                @clear="filterProj(null)"
                @change="handleProjChange"
                @focus="onProjSelectFocus">
                <el-option
                  v-for="item in projList"
                  :key="item.projId"
                  :title="item.projName"
                  :label="item.projName"
                  :value="item.projId" />
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">文件名称：</div>
            <div class="common-input-box">
              <el-input
                class="input-primary"
                size="mini"
                clearable
                placeholder="请输入文件名称"
                v-model="fileName" />
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">下载人：</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="mini"
                remote
                filterable
                clearable
                v-model="userId"
                :loading="filterUserLoading"
                :remote-method="filterUserList"
                :popper-append-to-body="false"
                placeholder="请选择下载人"
                @clear="filterUserList(null)"
                @focus="onUserSelectFocus">
                <div
                  class="infinite-scroll-box"
                  v-infinite-scroll="handleUserListScroll">
                  <el-option
                    v-for="item in userList"
                    :key="item.userId"
                    :label="item.surname"
                    :value="item.userId" />
                </div>
              </el-select>
            </div>
          </div>
          <div class="filter-item-box">
            <div class="label-box searchLabel">文件来源：</div>
            <div class="common-select-box">
              <el-select
                class="primary-select"
                size="mini"
                clearable
                v-model="fileSource"
                :popper-append-to-body="false"
                placeholder="请选择文件来源">
                <el-option
                  v-for="(item, index) in fileSourceList"
                  :key="index"
                  :value="item.value"
                  :label="item.name">
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="common-button-box">
          <el-button
            size="small"
            class="primary-btn"
            type="primary"
            @click="search">
            查询
          </el-button>
          <el-button
            size="small"
            class="normal-btn"
            @click="resetFilter"
            >重置</el-button
          >
        </div>
      </div>
      <div class="bottom-box">
        <div class="filter-box">
          <div class="filter-item-box">
            <div class="label-box searchLabel">下载日期：</div>
            <div class="common-datepicker-box">
              <el-date-picker
                class="date-picker-primary"
                v-model="dateValue"
                type="daterange"
                size="mini"
                :clearable="false"
                popper-class="datepicker-popper-box"
                :editable="false"
                :append-to-body="false"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions" />
            </div>
            <div class="time-tab-box">
              <div
                :class="getTimeTabClassName('day')"
                @click="timeTabClick('day')">
                今天
              </div>
              <div
                :class="getTimeTabClassName('week')"
                @click="timeTabClick('week')">
                一周以内
              </div>
              <div
                :class="getTimeTabClassName('month')"
                @click="timeTabClick('month')">
                一月以内
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        class="publish-table"
        highlight-selection-row
        ref="table"
        :header-row-class-name="customHeader"
        :data="downloadDataList"
        height="100%">
        <el-table-column
          label="序号"
          type="index"
          width="75" />
        <el-table-column label="文件名称">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.exceptionMessage">
              {{ row.fileName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所属项目">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.projName">
              {{ row.projName ? row.projName : '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="文件来源"
          width="180">
          <template v-slot="{ row }">
            <div>
              {{ getFileSource(row.sourceType) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="下载人"
          width="180">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.userName">
              {{ row.userName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="下载时间"
          width="180">
          <template v-slot="{ row }">
            <div>
              {{ row.downloadTime ? formatTime(row.downloadTime) : '--' }}
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">没有找到相关内容</template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
    <div class="common-pagination-box">
      <el-pagination
        class="pagination-primary"
        popper-class="common-pagination-popper-box"
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 150, 200]"
        :page-size="pageSize"
        :current-page="currPage"
        :total="total"
        @size-change="sizeChange"
        @current-change="pageChange" />
    </div>
  </div>
</template>

<script>
import { formatTime } from '@/utils/generalMethods'

import {
  getSingleProjectList,
  getUserNameList,
  getFileDownloadRecordService
} from '@/service/interface'

export default {
  data() {
    return {
      filterProjLoading: false,
      projList: [],
      projId: '',
      projName: '',

      fileName: '',
      customHeader: '',
      userId: undefined,
      filterValue: '',
      filterUserLoading: false,
      allUserLoaded: false,
      userList: [],
      currentPage: 1,
      userListPageSize: 20,

      fileSource: undefined,
      fileSourceList: [
        { name: 'BIM模型', value: 0 },
        { name: '遥感影像', value: 3 },
        { name: 'WMTS地图服务', value: 1 },
        { name: '倾斜摄影', value: 2 },
        { name: '360全景', value: 4 },
        { name: '点云', value: 5 },
        { name: '二维图纸', value: 6 },
        { name: '矢量数据', value: 7 },
        { name: '公共构件', value: 8 },
        { name: '我的构件', value: 9 },
        { name: 'Rvt外部贴图', value: 10 },
        { name: '数据导出', value: 11 },
        { name: '数据导入', value: 12 },
        { name: '离线数据包', value: 13 },
        { name: '其他', value: 14 }
      ],

      dateValue: [],
      currTimeTab: 'day',
      pickerOptions: {
        disabledDate: date => {
          let currTime = new Date()
          let todayTime = new Date(currTime.toDateString()).getTime()
          let dateTime = date.getTime()

          return dateTime > todayTime
        },
        onPick: eventInfo => {
          let { maxDate, minDate } = eventInfo
          if (minDate && maxDate) {
            let deltaTime = maxDate.getTime() - minDate.getTime()
            if (deltaTime > 30 * 24 * 60 * 60 * 1000) {
              this.$message.warning('时间跨度不能超过一个月,请重新选择')
              this.$nextTick(() => {
                this.dateValue = []
              })
            }
            this.currTimeTab = ''
          }
        }
      },

      downloadDataList: [],
      total: 0,
      currPage: 1,
      pageSize: 10
    }
  },
  mounted() {
    const currentBody = this.$refs.table.bodyWrapper
    currentBody.addEventListener('scroll', ev => {
      const scrollTop = ev.target.scrollTop
      this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
    })
    this.init()
  },
  methods: {
    init() {
      this.initProjList()
      this.initUserList()
      this.initDateValue()

      this.queryDownloadData().then(downloadDataList => {
        this.downloadDataList = downloadDataList
      })
    },
    initDateValue() {
      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const beginTime = todayZeroHour.getTime() - 1000

      let startTime = new Date(beginTime)
      let endTime = new Date(beginTime + 24 * 60 * 60 * 1000)

      this.dateValue = [startTime, endTime]
    },
    initUserList() {
      this.queryUserList().then(userList => {
        this.userList = userList
      })
    },
    filterUserList(filterValue) {
      this.filterValue = filterValue

      this.currentPage = 1
      this.allUserLoaded = false

      this.filterUserLoading = true
      this.queryUserList().then(userList => {
        this.userList = userList
        this.filterUserLoading = false
      })
    },
    onUserSelectFocus() {
      this.userId = ''
      this.filterUserList('')
    },
    handleUserListScroll() {
      if (this.allUserLoaded || this.filterValue) return
      this.currentPage++
      this.queryUserList().then(userList => {
        if (userList.length) {
          this.userList = [...this.userList, ...userList]
        } else {
          this.allUserLoaded = true
        }
      })
    },
    initProjList() {
      getSingleProjectList({}).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    filterProj(filterName) {
      let projName = filterName

      this.filterProjLoading = true
      getSingleProjectList({ projName }).then(response => {
        if (response.isSuccess) {
          let projList = response.data
          this.projList = projList
          this.filterProjLoading = false
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    onProjSelectFocus() {
      this.projId = ''
      this.filterProj('')
    },
    handleProjChange(value) {
      let find = this.projList.find(el => el.projId === value)
      this.projName = find.projName
    },
    timeTabClick(tabName) {
      this.currTimeTab = tabName

      // 获取当前日期
      const today = new Date()
      // prettier-ignore
      const todayZeroHour = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      let startTime = null
      let endTime = todayZeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      if (tabName === 'day') {
        startTime = new Date(endTime - 24 * 60 * 60 * 1000)
      }

      if (tabName === 'week') {
        startTime = new Date(endTime - 7 * 24 * 60 * 60 * 1000)
      }

      if (tabName === 'month') {
        startTime = new Date(endTime - 30 * 24 * 60 * 60 * 1000)
      }

      endTime = new Date(endTime)
      this.dateValue = [startTime, endTime]
    },
    getTimeTabClassName(tabName) {
      let className = 'tab-item-box'
      if (tabName === this.currTimeTab) {
        className += ' tab-active'
      }
      return className
    },
    getFileSource(sourceType) {
      let find = this.fileSourceList.find(el => el.value === sourceType)
      return find ? find.name : '--'
    },
    search() {
      this.currPage = 1
      this.queryDownloadData().then(downloadDataList => {
        this.downloadDataList = downloadDataList
      })
    },
    resetFilter() {
      this.projName = ''
      this.fileName = ''

      this.userId = undefined
      this.filterValue = ''
      this.fileSource = undefined
      this.currTimeTab = 'day'
      this.initDateValue()
      this.currPage = 1
      this.queryDownloadData().then(downloadDataList => {
        this.downloadDataList = downloadDataList
      })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.queryDownloadData().then(downloadDataList => {
        this.downloadDataList = downloadDataList
      })
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.queryDownloadData().then(downloadDataList => {
        this.downloadDataList = downloadDataList
      })
    },
    queryUserList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: this.userListPageSize,
          skipCount: (this.currentPage - 1) * this.userListPageSize,
          searchType: 'surname',
          filter: this.filterValue
        }
        getUserNameList(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              let userList = data.items
              resolve(userList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    queryDownloadData() {
      return new Promise(resolve => {
        let params = {
          projName: this.projName,
          fileName: this.fileName,
          // prettier-ignore
          sourceType: typeof this.fileSource === "number" ? this.fileSource : undefined,
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }

        if (this.dateValue.length) {
          params.startTime = this.formatDate(this.dateValue[0])
          params.endTime = this.formatDate(this.dateValue[1])
        }
        if (this.userId) {
          params.userIds = [this.userId]
        }
        getFileDownloadRecordService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let downloadDataList = data.items
            this.total = data.totalCount
            resolve(downloadDataList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatDate(dateTime) {
      // prettier-ignore
      const zeroHour = new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());

      let formatDateTime = zeroHour.getTime() + 24 * 60 * 60 * 1000 - 1000
      formatDateTime = formatTime(new Date(formatDateTime))
      return formatDateTime
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.exception-logs-box {
  height: 100%;

  .title-box {
    display: flex;
    align-items: center;

    .symbol {
      width: 4px;
      height: 20px;
      background: var(--base-primary-bgColor);
    }

    .title {
      margin-left: 10px;
      color: var(--page-title-color);
    }
  }

  .operation-box {
    display: flex;
    flex-direction: column;

    .filter-box {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(4, 1fr);

      .filter-item-box {
        display: flex;
        align-items: center;
        margin-right: 15px;

        .searchLabel {
          white-space: nowrap;
        }

        :deep(.el-input__inner) {
          height: 32px;
        }

        .common-input-box {
          width: 100%;
        }

        .common-select-box {
          width: 100%;
          text-align: left;

          .infinite-scroll-box {
            // max-height: 240px;
            overflow-y: auto;
          }

          .el-select {
            width: 100%;
          }
        }

        .common-datepicker-box {
          // width: 240px;

          .el-date-editor {
            width: 100%;
          }
        }

        .time-tab-box {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 16px;

          .tab-item-box {
            margin-right: 10px;
            padding: 5px 10px;
            font-size: 14px;
            border-radius: 8px;
            cursor: pointer;
            border: 1px solid var(--api-search-time-border-color);
            background-color: var(--api-search-time-bgColor);
            color: var(--api-search-time-text-color);
            white-space: nowrap;

            &:hover {
              color: var(--base-primary-bgColor);
              border-color: var(--base-primary-bgColor);
            }
          }

          .tab-active {
            color: var(--base-primary-bgColor);
            border-color: var(--base-primary-bgColor);
            background-color: var(--base-bg-light-color24);
          }
        }
      }
    }

    .common-button-box {
      display: flex;
      flex-wrap: nowrap;
    }

    .top-box {
      margin-bottom: 16px;
      display: flex;
      column-gap: 120px;
      justify-content: space-between;
    }

    .bottom-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }
  }

  .common-table-box {
    height: calc(100% - 239px);
    padding: 0 16px;
  }
}
</style>
